import styled from "styled-components";
import COLORS from "../../constants/colors";

export const WholeWrapper = styled.div`
  width: 10.4rem;
  min-height: 100%;
  background: ${COLORS.primary.oxford};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.2rem 0;
`;

export const SidebarItem = styled.div`
  &.closer {
    height: 6.4rem;
  }
  width: 10.4rem;
  height: 8.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
